import React from "react";
import { RotaCheckbox } from "@teamrota/rota-design";

const ToggleOption = ({ label, isChecked, onToggle }) => {
  return (
    <RotaCheckbox label={label} isChecked={isChecked} onClick={onToggle} />
  );
};

export default ToggleOption;
